import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import { BedIcon, BathIcon, GarageIcon } from '@domain-group/fe-co-icon';
import Footer from './footer-old';
import { subtitlePrefix, subtitleSuffix, truncateTextToNearestSpace } from './utils';
import * as styles from './modal-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var MAX_DESCRIPTION_LENGTH = 165;
var ModalCard = props => {
  var _props$review = props.review,
    title = _props$review.title,
    date = _props$review.date,
    type = _props$review.type,
    description = _props$review.description,
    trackingPixelUrl = _props$review.trackingPixelUrl,
    propertyFeatures = _props$review.propertyFeatures,
    propertyAddress = _props$review.propertyAddress;
  var bedrooms = propertyFeatures.bedrooms,
    bathrooms = propertyFeatures.bathrooms,
    parking = propertyFeatures.parking;
  var streetAddress = propertyAddress.streetAddress,
    suburb = propertyAddress.suburb,
    state = propertyAddress.state;
  var address = "".concat(streetAddress, ", ").concat(suburb, " ").concat(state.toUpperCase());
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.container, styles.animation(props.animation)]),
    onAnimationEnd: props.onAnimationEnd
  }, ___EmotionJSX("div", {
    css: styles.title
  }, title, trackingPixelUrl && ___EmotionJSX("img", {
    alt: "",
    src: trackingPixelUrl
  })), ___EmotionJSX("div", {
    css: styles.subtitle
  }, ___EmotionJSX("span", {
    css: styles.subtitlePrefix
  }, subtitlePrefix(type, propertyAddress === null || propertyAddress === void 0 ? void 0 : propertyAddress.suburb)), ___EmotionJSX("span", {
    css: styles.subtitleSuffix
  }, subtitleSuffix(date))), ___EmotionJSX("p", null, props.show ? description : truncateTextToNearestSpace(description, MAX_DESCRIPTION_LENGTH)), ___EmotionJSX("div", {
    css: styles.address
  }, ___EmotionJSX("div", {
    css: styles.addressBody
  }, address), ___EmotionJSX("div", {
    css: styles.features
  }, bedrooms && ___EmotionJSX("div", null, ___EmotionJSX(BedIcon, null), ___EmotionJSX("div", {
    css: styles.feature
  }, bedrooms.toString())), (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.total) && ___EmotionJSX("div", null, ___EmotionJSX(BathIcon, null), ___EmotionJSX("div", {
    css: styles.feature
  }, bathrooms.total.toString())), (parking === null || parking === void 0 ? void 0 : parking.total) && ___EmotionJSX("div", null, ___EmotionJSX(GarageIcon, null), ___EmotionJSX("div", {
    css: styles.feature
  }, parking.total.toString())))), ___EmotionJSX(Footer, null));
};
ModalCard.propTypes = {
  animation: PropTypes.oneOf(['exitToLeft', 'enterFromRight', 'exitToRight', 'enterFromLeft']).isRequired,
  review: PropTypes.shape({
    title: PropTypes.string,
    date: PropTypes.string,
    type: PropTypes.string,
    description: PropTypes.string,
    trackingPixelUrl: PropTypes.string,
    propertyFeatures: PropTypes.shape({
      bedrooms: PropTypes.number,
      bathrooms: PropTypes.shape({
        total: PropTypes.number
      }),
      parking: PropTypes.shape({
        total: PropTypes.number
      })
    }),
    propertyAddress: PropTypes.shape({
      streetAddress: PropTypes.string,
      suburb: PropTypes.string,
      state: PropTypes.string
    })
  }),
  onAnimationEnd: PropTypes.func,
  show: PropTypes.bool
};
ModalCard.defaultProps = {
  review: {},
  onAnimationEnd: () => {},
  show: false
};
export { ModalCard, MAX_DESCRIPTION_LENGTH };